import { render, staticRenderFns } from "./UsersShiftsManager.vue?vue&type=template&id=29996a8a"
import script from "./UsersShiftsManager.vue?vue&type=script&lang=js"
export * from "./UsersShiftsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports